import React from "react";
import PropTypes from "prop-types";
import "@fortawesome/react-fontawesome";
import { SocialIcon } from "react-social-icons";
import { graphql } from "gatsby";

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  RedditShareButton
} from "react-share";

import { Row, Col } from "reactstrap";

import "./share.scss";

const Share = ({ socialConfig, tags }) => (
  <Row className="post-share">
    <Col>
      <h1 className="pb-3">Share</h1>
      <FacebookShareButton
        url={socialConfig.config.url}
        className="btn facebook"
      >
        <SocialIcon network="facebook" style={{ height: 35, width: 35 }} />
      </FacebookShareButton>
      <TwitterShareButton
        url={socialConfig.config.url}
        className="btn is-outlined is-rounded twitter"
        title={socialConfig.config.title}
        via={socialConfig.twitterHandle.split(`@`).join(``)}
        hashtags={tags}
      >
        <SocialIcon network="twitter" style={{ height: 35, width: 35 }} />
      </TwitterShareButton>
      <LinkedinShareButton
        url={socialConfig.config.url}
        className="btn is-outlined is-rounded linkedin"
        title={socialConfig.config.title}
      >
        <SocialIcon network="linkedin" style={{ height: 35, width: 35 }} />
      </LinkedinShareButton>
      <RedditShareButton
        url={socialConfig.config.url}
        className="btn is-outlined is-rounded reddit"
        title={socialConfig.config.title}
      >
        <SocialIcon network="reddit" style={{ height: 35, width: 35 }} />
      </RedditShareButton>
      <WhatsappShareButton
        url={socialConfig.config.url}
        className="btn is-outlined is-rounded whatsapp"
        title={socialConfig.config.title}
      >
        <SocialIcon network="whatsapp" style={{ height: 35, width: 35 }} />
      </WhatsappShareButton>
    </Col>
  </Row>
);

Share.propTypes = {
  socialConfig: PropTypes.shape({
    twitterHandle: PropTypes.string.isRequired,
    config: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  }).isRequired,
  tags: PropTypes.arrayOf(PropTypes.string)
};
Share.defaultProps = {
  tags: []
};

export const query = graphql`
  fragment ShareInformation on Site {
    siteMetadata {
      url
      twitterHandle
    }
  }
`;

export default Share;
